module.exports = __webpack_public_path__ + "img/mitsu-Used.13e68ee3.png";